import { render, staticRenderFns } from "./CompanyMultiRestaurantTabTopup.vue?vue&type=template&id=222c1d99&scoped=true"
import script from "./CompanyMultiRestaurantTabTopup.vue?vue&type=script&lang=js"
export * from "./CompanyMultiRestaurantTabTopup.vue?vue&type=script&lang=js"
import style0 from "./CompanyMultiRestaurantTabTopup.vue?vue&type=style&index=0&id=222c1d99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222c1d99",
  null
  
)

export default component.exports